'use client';

import { PageGrid, PageGridItem } from 'corgi/common/components/PageGrid';
import ContactForm from 'corgi/contact-form/components/ContactForm';

import { GridGutter, GridPaddingX } from '@components/myaccount/body/styles';
import type { ContactPageProps } from '@utils/transformers/myaccount/contact-form';

const ContactFormBody = ({ contactFormProps }: Pick<ContactPageProps, 'contactFormProps'>) => (
  <PageGrid
    maxWidth={1600}
    flexDirection="column"
    alignItems="center"
    px={GridPaddingX}
    py={['sp_20', 'sp_20', 'sp_24', 'sp_32']}
  >
    <PageGridItem
      width={[1, '75%', '50%', '33.3%']}
      maxWidth={['none', '450px', 'none']}
      px={GridGutter}
    >
      <ContactForm {...contactFormProps} />
    </PageGridItem>
  </PageGrid>
);

export default ContactFormBody;
